module.exports = __webpack_public_path__ + "static/pic3-d9f07b620a47345cb34d2ed3df71a0f5.jpg";